import { ListEntity } from "models/list-entity";
import { Fragment, FunctionComponent } from "react";
import { useListEntities } from "stores/hooks/list-entities";
import { useNavigate } from "react-router";
import Form from "components/forms/form";
import FormButtons from "components/forms/buttons";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormValues } from "lib/form";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import ListEntityMultiTable from "./multi-table";
import { List } from "models/list";

interface UserListEntityMultiProps {
  list: List;
  listEntity: ListEntity;
}

const UserListEntityMulti: FunctionComponent<UserListEntityMultiProps> = ({
  list,
  listEntity,
}) => {
  const navigate = useNavigate();
  const entities = useListEntities();

  const methods = useForm({
    resolver: yupResolver(yup.object()),
    defaultValues: {},
  });

  // this form is entirely for navigation, the values are stored
  const index = entities.findIndex((ent) => ent.uuid === listEntity.uuid);

  const onSubmit = async (_values: FormValues) => {
    // from last entity we go to summary
    if (listEntity.order === entities.length - 1) {
      navigate(`/user/list/${list.uuid}/summary`);
    } else {
      const nextEntity = entities[index + 1];
      navigate(`/user/list/${list.uuid}/entity/${nextEntity.uuid}`);
    }
  };

  const onPrevious = async () => {
    // from first entity we go to obligation (if enabled)
    if (listEntity.order === 0) {
      navigate(`/user/list/${list.uuid}/obligation`);
    } else {
      const nextEntity = entities[index - 1];
      navigate(`/user/list/${list.uuid}/entity/${nextEntity.uuid}`);
    }
  };

  return (
    <Fragment>
      <ListEntityMultiTable listUuid={list.uuid} listEntity={listEntity} />
      <Form onSubmit={onSubmit} methods={methods}>
        <FormButtons
          buttons={[
            {
              ...CancelButton,
              text: "Edelliseen",
              align: "left",
              onClick: onPrevious,
            },
            {
              ...SubmitButton,
              text: "Tallenna ja jatka",
              align: "right",
            },
          ]}
        />
      </Form>
    </Fragment>
  );
};

export default UserListEntityMulti;
